// A prerendered 404 or 410 page serves every failed address, so the page works
// out which show was asked for from the browser's address.
export function slugFromErrorPath(pathname = "") {
  const match = /^\/(?:show|shows-like)\/([^/]+)\/?$/.exec(pathname);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

// "would-i-lie-to-you-2007" -> "would i lie to you"
export function slugToSearchQuery(slug = "") {
  return String(slug)
    .replace(/-(?:19|20)\d{2}$/, "")
    .replace(/-+/g, " ")
    .trim();
}
